import { CustomInput } from '@/styles/components/CustomInput';
import { CustomSelect } from '@/styles/components/CustomSelect';
import { Select, SelectProps } from 'antd';
import { SelectValue } from 'antd/lib/select';
import React, { useEffect, useState } from 'react';
import emptyIcon from '@/images/empty/none-content.svg';
import { EmptyWrap, SelectWrap } from './style';
import { useTranslation } from 'react-i18next';
import redioIcon from '@/images/common/select/redio-checked.svg';
import searchIcon from '@/images/common/search/search.svg';
type IPorps = {
	selectData?: {
		seleceKey: string;
		selectLabel: string;
		selectTree: {
			[key: string]: string;
		}[];
	};
	isSearch?: Boolean;
} & SelectProps<SelectValue>;
const SelectNode = ({ selectData, isSearch = false, onChange, value, ...selectProps }: IPorps) => {
	const { t } = useTranslation();
	const [selectList, setSelectList] = useState<{
		seleceKey: string;
		selectLabel: string;
		selectTree: {
			[key: string]: string;
		}[];
	}>();
	const [search, setSearch] = useState<string>('');
	useEffect(() => {
		setSelectList(selectData);
	}, [JSON.stringify(selectData)]);
	const handelFilter = (e: React.KeyboardEvent<HTMLInputElement>) => {
		if (selectData && selectList) {
			let newList = selectData?.selectTree.filter((item) => {
				return item[selectData.selectLabel].indexOf(search) !== -1;
			});
			let newSelect = {
				seleceKey: selectList.seleceKey,
				selectLabel: selectList.selectLabel,
				selectTree: newList,
			};
			// 将列表的值筛选出来
			setSelectList(newSelect);
		}
		e.stopPropagation();
	};
	return (
		<CustomSelect
			dropdownMatchSelectWidth={false}
			value={value}
			dropdownRender={(node) => {
				return (
					<SelectWrap
						onClick={(e) => {
							e.stopPropagation();
						}}>
						{isSearch && (
							<>
								<div className="search">
									<CustomInput
										allowClear={true}
										value={search}
										onChange={(e) => {
											setSearch(e.target.value);
										}}
										placeholder={t('common.search')}
										onPressEnter={(e) => {
											handelFilter(e);
										}}
										suffix={search ? <span></span> : <img src={searchIcon} />}
									/>
								</div>
								<div className="divider"></div>
							</>
						)}
						{selectList &&
						selectData &&
						selectList.selectTree.length === 0 &&
						selectData.selectTree.length !== 0 ? (
							<EmptyWrap>
								<img src={emptyIcon} alt="" />
								<div>{t('common.wasNotFound')}</div>
							</EmptyWrap>
						) : (
							node
						)}
					</SelectWrap>
				);
			}}
			{...selectProps}
			onChange={onChange}>
			{selectList &&
				selectList.selectTree.map((selectItem) => (
					<Select.Option
						key={selectItem[selectList?.seleceKey]}
						value={selectItem[selectList?.seleceKey]}>
						<div className="select-label-wrap">
							{selectItem[selectList?.selectLabel]}
							{selectItem[selectList?.seleceKey] === value && <img src={redioIcon} />}
						</div>
					</Select.Option>
				))}
		</CustomSelect>
	);
};

export default SelectNode;
